module.exports = __webpack_public_path__ + "static/media/icon-partner.212c6579.svg";